import { render, staticRenderFns } from "./bangzhuzhongxin.vue?vue&type=template&id=3061b397&scoped=true"
import script from "./bangzhuzhongxin.vue?vue&type=script&lang=js"
export * from "./bangzhuzhongxin.vue?vue&type=script&lang=js"
import style0 from "./bangzhuzhongxin.vue?vue&type=style&index=0&id=3061b397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061b397",
  null
  
)

export default component.exports